import BankAccountFormConfig from "./form";
import { BankAccountApi, BankAccountDataType } from "@/api/BankAccountApi";
import { BankAccountFormData } from "@/formTypes/BankAccountFormDataType";
import GenericForm from "../GenericForm";

type BankAccountFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const BankAccountForm = (props: BankAccountFormProps) => {

  return (
    <GenericForm<BankAccountFormData, BankAccountDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={BankAccountFormConfig}
      getById={(...arg) => BankAccountApi.get(...arg)}
      createFn={(...arg) => BankAccountApi.create(...arg)}
      updateFn={(...arg) => BankAccountApi.update(...arg)}
      successMessage="La Cuenta bancaria ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información de la cuenta bancaria"
    />
  )
}

export default BankAccountForm;